<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <v-text-field
          v-model="search"
          append-icon="mdi-table-search"
          label="Suche"
          single-line
          hide-details
        />
      </v-col>
    </v-row>

    <v-data-table
      ref="table"
      :headers="headers"
      :items="contracts"
      :search="search"
      :options.sync="options"
      :expanded.sync="expandedContracts"
      show-expand
      :footer-props="{
        itemsPerPageOptions: [-1, 50, 25, 10],
      }"
    >
      <template #[`item.start_date`]="{ item }">
        <span>{{ getDateString(item.start_date) }}</span>
      </template>
      <template #[`item.offer.get_data.orderer.company.name`]="{ item }">
        <inertia-link
          :href="
            route('customer.show.uebersicht', {
              customer: item.offer.get_data.orderer.company.id,
            })
          "
        >
          <span>{{ item.offer.get_data.orderer.company.name }}</span>
        </inertia-link>
      </template>
      <template #[`item.turnover`]="{ item }">
        <span> {{ moneyFormatter.format(item.turnover) }}</span>
      </template>
      <template #[`item.monthly_turnover`]="{ item }">
        <span> {{ moneyFormatter.format(item.monthly_turnover) }}</span>
      </template>
      <template #[`item.turnover_one_time`]="{ item }">
        <span> {{ moneyFormatter.format(item.turnover_one_time) }}</span>
      </template>
      <template #[`item.end_date`]="{ item }">
        <span>{{ getDateString(item.end_date) }}</span>
      </template>
      <template #[`item.debitor`]="{ item }">
        <span>  {{ item?.debitor?.name ?? '' }}</span>
      </template>
      <template #[`item.content`]="{ item }">
        <InvoicedSnippet :flag="item.invoiceFlag" />
      </template>
      <template #[`item.actions`]="{ item }">
        <v-menu v-if="actionMenu" offset-y>
          <template #activator="{ on }">
            <v-btn v-on="on">
              aktionen
            </v-btn>
          </template>
          <v-list>
            <v-list-item
              @click.stop="
                visitPage(
                  route('contracts.enlargements.index', { contract: item.id })
                )
              "
            >
              <v-list-item-icon>
                <v-icon> mdi-bookmark-plus-outline </v-icon>
              </v-list-item-icon>
              <v-list-item-title> Erweiterung </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>

        <div v-else>
          <v-tooltip bottom>
            <template #activator="{ on }">
              <v-icon
                v-on="on"
                @click.stop="
                  visitPage(
                    route('contracts.enlargements.index', { contract: item.id })
                  )
                "
              >
                mdi-bookmark-plus-outline
              </v-icon>
            </template>
            <span> Erweiterung </span>
          </v-tooltip>
        </div>
      </template>
      <template #expanded-item="{ headers: expanedheaders, item }">
        <td :colspan="expanedheaders.length" class="pa-5 pl-14 elevation-0">
          <h2>Verträge</h2>
          <v-simple-table dense>
            <template #default>
              <thead>
                <tr>
                  <th class="text-left">
                    Status
                  </th>
                  <th class="text-left">
                    Nr.
                  </th>
                  <th class="text-left">
                    Umsatz
                  </th>
                  <th class="text-left">
                    Umsatz einmalig
                  </th>
                  <th class="text-left">
                    Umsatz/Monat
                  </th>
                  <th class="text-left">
                    Laufzeit in M
                  </th>
                  <th class="text-left">
                    Startdatum
                  </th>
                  <th class="text-left">
                    Enddatum
                  </th>
                  <th class="text-left">
                    Pflichtdateien
                  </th>
                  <th class="text-left">
                    Inhalt
                  </th>
                  <th class="text-left">
                    Aktionen
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="enlargement in item.created_contracts"
                  :key="enlargement.id"
                >
                  <td>
                    {{ enlargement.status }}
                  </td>
                  <td>
                    {{ enlargement.number }}
                  </td>
                  <td>
                    {{ moneyFormatter.format(enlargement.turnover) }}
                  </td>
                  <td>
                    {{ moneyFormatter.format(enlargement.turnover_one_time) }}
                  </td>
                  <td>
                    {{ moneyFormatter.format(enlargement.monthly_turnover) }}
                  </td>
                  <td>
                    {{ enlargement.months }}
                  </td>
                  <td>
                    {{ getDateString(enlargement.start_date) }}
                  </td>
                  <td>
                    {{ getDateString(enlargement.end_date) }}
                  </td>
                  <td>
                    <RequiredFilesAsIcons
                      :file-groups="enlargement.required_file_groups"
                    />
                  </td>
                  <td>
                    <InvoicedSnippet :flag="enlargement.invoiceFlag" />
                  </td>
                  <td>
                    <inertia-link
                      :href="route('offerData.show', enlargement.id)"
                    >
                      <v-tooltip bottom>
                        <template #activator="{ on, attrs }">
                          <v-icon class="mr-3" v-bind="attrs" v-on="on">
                            mdi-eye
                          </v-icon>
                        </template>
                        <span>öffnen</span>
                      </v-tooltip>
                    </inertia-link>
                  </td>
                </tr>
                <tr style="font-weight: bold">
                  <td>Gesamt</td>
                  <td />
                  <td>
                    {{ moneyFormatter.format(item.turnover) }}
                  </td>
                  <td>
                    {{ moneyFormatter.format(item.turnover_one_time) }}
                  </td>
                  <td>
                    {{ moneyFormatter.format(item.monthly_turnover) }}
                  </td>
                  <td>
                    {{ item.months }}
                  </td>
                  <td>
                    {{ getDateString(item.start_date) }}
                  </td>
                  <td>
                    {{ getDateString(item.end_date) }}
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
          <h2>Offene Angebote zu dem Grundvertrag</h2>
          <v-simple-table dense>
            <template #default>
              <thead>
                <tr>
                  <th class="text-left">
                    Status
                  </th>
                  <th class="text-left">
                    Nr.
                  </th>
                  <th class="text-left">
                    Umsatz
                  </th>
                  <th class="text-left">
                    Umsatz einmalig
                  </th>
                  <th class="text-left">
                    Umsatz/Monat
                  </th>
                  <th class="text-left">
                    Laufzeit in M
                  </th>
                  <th class="text-left">
                    Potentielles Startdatum
                  </th>
                  <th class="text-left">
                    Enddatum Hauptvertrag
                  </th>
                  <th class="text-left">
                    Inhalt
                  </th>
                  <th class="text-left">
                    Aktionen
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="offer in item.created_offers" :key="offer.id">
                  <td>
                    {{ offer.status }}
                  </td>
                  <td>
                    {{ offer.number }}
                  </td>
                  <td>
                    {{ moneyFormatter.format(offer.turnover) }}
                  </td>
                  <td>
                    {{ moneyFormatter.format(offer.turnover_one_time) }}
                  </td>
                  <td>
                    {{ moneyFormatter.format(offer.monthly_turnover) }}
                  </td>
                  <td>
                    {{ offer.months }}
                  </td>
                  <td>
                    {{ getDateString(offer.start_date) }}
                  </td>
                  <td>
                    {{ getDateString(item.end_date) }}
                  </td>
                  <td />
                  <td>
                    <inertia-link :href="route('offerData.show', offer.id)">
                      <v-tooltip bottom>
                        <template #activator="{ on, attrs }">
                          <v-icon class="mr-3" v-bind="attrs" v-on="on">
                            mdi-eye
                          </v-icon>
                        </template>
                        <span>öffnen</span>
                      </v-tooltip>
                    </inertia-link>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
          <h2>Offene Preisinformationen zu dem Grundvertrag</h2>
          <v-simple-table dense>
            <template #default>
              <thead>
                <tr>
                  <th class="text-left">
                    Status
                  </th>
                  <th class="text-left">
                    Nr.
                  </th>
                  <th class="text-left">
                    Umsatz
                  </th>
                  <th class="text-left">
                    Umsatz einmalig
                  </th>
                  <th class="text-left">
                    Umsatz/Monat
                  </th>
                  <th class="text-left">
                    Laufzeit in M
                  </th>
                  <th class="text-left">
                    Potentielles Startdatum
                  </th>
                  <th class="text-left">
                    Enddatum Hauptvertrag
                  </th>
                  <th class="text-left">
                    Inhalt
                  </th>
                  <th class="text-left">
                    Aktionen
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="price_info in item.created_price_informations"
                  :key="price_info.id"
                >
                  <td>
                    {{ price_info.status }}
                  </td>
                  <td>
                    {{ price_info.number }}
                  </td>
                  <td>
                    {{ moneyFormatter.format(price_info.turnover) }}
                  </td>
                  <td>
                    {{ moneyFormatter.format(price_info.turnover_one_time) }}
                  </td>
                  <td>
                    {{ moneyFormatter.format(price_info.monthly_turnover) }}
                  </td>
                  <td>
                    {{ price_info.months }}
                  </td>
                  <td>
                    {{ getDateString(price_info.start_date) }}
                  </td>
                  <td>
                    {{ getDateString(item.end_date) }}
                  </td>
                  <td>
                    <ContentAsIcons :item="price_info" />
                  </td>
                  <td>
                    <inertia-link
                      :href="route('offerData.show', price_info.id)"
                    >
                      <v-tooltip bottom>
                        <template #activator="{ on, attrs }">
                          <v-icon class="mr-3" v-bind="attrs" v-on="on">
                            mdi-eye
                          </v-icon>
                        </template>
                        <span>öffnen</span>
                      </v-tooltip>
                    </inertia-link>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </td>
        <!-- eslint-enable -->
      </template>
    </v-data-table>

    <v-divider />
    <v-row class="mt-2 mr-5 justify-end">
      <span>Gesamt Umsatz {{ moneyFormatter.format(turnover) }}</span>
      <span class="ml-5">Gesamt Umsatz Einmalig: {{ moneyFormatter.format(singleTurnover) }}</span>
      <span class="ml-5">Gesamt Umsatz Monatlich: {{ moneyFormatter.format(monthlyTurnover) }}</span>
    </v-row>
  </v-container>
</template>

<script>
import Layout from '@/Layouts/Default'
import { formattedDateString } from '@/plugins/formatDate.js'
import RequiredFilesAsIcons from '@/Components/Contract/RequiredFilesAsIcons'
import ContentAsIcons from '@/Components/Contract/ContentAsIcons'
import InvoicedSnippet from '@/Components/Contract/Snippets/InvoicedSnippet'

export default {
   components: {
      RequiredFilesAsIcons,
      ContentAsIcons,
      InvoicedSnippet
   },
   metaInfo () {
      // don't know your return object structure,
      // maybe you should check whole this.getViewPage
      return {
         title: this.title ? this.title : 'Verträge',
      }
   },
   layout: (h, page) => h(Layout, [page]),
   props: {
      contracts: {
         type: Array,
         required: true,
      },
   },
   remember: {
      data: ['options', 'search'],
      key: 'Contract/Index',
   },
   data () {
      return {
         expandedContracts: [],
         dialog: false,
         statuswahlOffer: null,
         search: '',
         headers: [
            {
               text: 'Nr.',
               align: 'start',
               value: 'number',
            },

            { text: 'Kunde', value: 'offer.get_data.orderer.company.name' },
            { text: 'Debitor', value: 'debitor' },
            { text: 'Umsatz', value: 'turnover' },
            { text: 'Umsatz Einmalig', value: 'turnover_one_time' },
            { text: 'Umsatz/Monat', value: 'monthly_turnover' },
            { text: 'Laufzeit in M', value: 'months' },

            { text: 'Startdatum', value: 'start_date' },
            { text: 'Enddatum', value: 'end_date' },
            { text: 'Inhalt', value: 'content' },
            { text: 'Aktionen', value: 'actions', sortable: false },
         ],
         contextMenuContract: null,
         contextMenuContractX: 0,
         contextMenuContractY: 0,
         moneyFormatter: new Intl.NumberFormat('de-DE', {
            style: 'currency',
            currency: 'EUR',
         }),
         options: {
            page: 1,
            itemsPerPage: 50,
            sortBy: ['created_at'],
            sortDesc: [true],
            multiSort: false,
         },
      }
   },
   computed: {
      actionMenu () {
         return this.$vuetify.breakpoint.width < 1264
      },
      monthlyTurnover () {
         let price = 0

         for (const contract of this.contracts) {
            price += contract.monthly_turnover
         }
         return price
      },
      singleTurnover () {
         let price = 0

         for (const contract of this.contracts) {
            price += contract.turnover_one_time
         }
         return price
      },
      turnover () {
         let price = 0

         for (const contract of this.contracts) {
            price += contract.turnover
         }
         return price
      }
   },
   methods: {
      getDateString (dateVal) {
         return formattedDateString(dateVal)
      },
      navigateToContract (_contract) {
         this.$inertia.visit(this.route('contract.show', _contract))
      },
      //   setcontextMenuContract (e, { item: contract }) {
      //      e.preventDefault()
      //      this.contextMenuContract = null
      //      this.contextMenuContractX = e.clientX
      //      this.contextMenuContractY = e.clientY
      //      this.$nextTick(() => {
      //         this.contextMenuContract = contract
      //      })
      //   },
      visitPage (route) {
         this.$inertia.visit(route)
      },

   },
}
</script>
